import cookie from 'js-cookie';

export const removeAblyCookie = (name: string): void => {
  cookie.remove(name, { domain: '.a-bly.com', path: '/' });
  cookie.remove(name, { path: '/' });
};
